(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyctrace-cart-policy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const note = document.querySelector('[data-cyc-cart-checkout-note]');
    const checkout = document.querySelector('#MainContent button[name="checkout"]');
    if (note && checkout) {
      checkout.parentElement.before(note);
      note.hidden = false;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyctrace-category-mega-nav"]) return;
  try {
    
  (() => {
    const panel = document.querySelector('[data-cyc-category-mega]');
    const header = document.querySelector('.t4s-section-header');
    if (!panel || !header) return;
    const triggerUrl = panel.dataset.triggerUrl;

    const triggerLink = Array.from(header.querySelectorAll('a[href]')).find((link) => {
      const href = link.getAttribute('href') || '';
      return href === triggerUrl || href.startsWith(`${triggerUrl}?`);
    });
    if (!triggerLink) return;

    const trigger = triggerLink.closest('li') || triggerLink;
    let closeTimer;

    trigger.classList.add('cyc-category-trigger');
    trigger.classList.remove('has--children', 't4s-type__mega', 'is-action__hover', 'menu-has__offsets', 'menu-width__cus');
    const legacyMenu = trigger.querySelector(':scope > .t4s-sub-menu');
    if (legacyMenu) legacyMenu.hidden = true;

    const updatePosition = () => {
      panel.style.setProperty('--cyc-mega-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    };

    const openPanel = () => {
      window.clearTimeout(closeTimer);
      updatePosition();
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      triggerLink.setAttribute('aria-expanded', 'true');
    };

    const closePanel = () => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      triggerLink.setAttribute('aria-expanded', 'false');
    };

    const closeLater = () => {
      closeTimer = window.setTimeout(closePanel, 140);
    };

    triggerLink.setAttribute('aria-haspopup', 'true');
    triggerLink.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('pointerenter', openPanel);
    trigger.addEventListener('pointerleave', closeLater);
    trigger.addEventListener('focusin', openPanel);
    trigger.addEventListener('focusout', closeLater);
    panel.addEventListener('pointerenter', () => window.clearTimeout(closeTimer));
    panel.addEventListener('pointerleave', closeLater);
    panel.addEventListener('focusin', () => window.clearTimeout(closeTimer));
    panel.addEventListener('focusout', closeLater);
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', () => {
      if (panel.classList.contains('is-open')) updatePosition();
    }, { passive: true });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closePanel();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyctrace-conversion-motion"]) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const selectors = [
      '.cyc-hero__copy', '.cyc-hero__visual', '.cyc-trust__grid > div',
      '.cyc-heading-row', '.cyc-ride-card', '.cyc-product-card', '.cyc-difference article',
      '.cyc-guide__intro', '.cyc-guide__steps li', '.cyc-policy > *', '.cyc-faq > *',
      '.cyc-cta .cyc-shell', '.cyc-collection-intro__copy', '.cyc-collection-intro__link',
      '.cyc-product-guide__head', '.cyc-product-guide__grid > *', '.cyc-confidence__heading',
      '.cyc-confidence article', '.cyc-cart-policy__inner > *', '.cyc-footer__benefit',
      '.template-collection .t4s-product', '.template-search .t4s-product',
      '.template-product .t4s-product__info-container'
    ];
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .06, rootMargin: '0px 0px -25px 0px' }) : null;
    const activate = (scope) => {
      scope.querySelectorAll(selectors.join(',')).forEach((element, index) => {
        if (element.classList.contains('cyc-reveal')) return;
        element.style.setProperty('--cyc-delay', `${Math.min(index % 4, 3) * 65}ms`);
        element.classList.add('cyc-reveal');
        if (observer) observer.observe(element);
        else element.classList.add('is-visible');
      });
      document.documentElement.classList.add('cyc-motion-ready');
    };
    activate(document);
    document.addEventListener('shopify:section:load', (event) => activate(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyctrace-global-policy-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const section = event.target.closest('.cyc-policybar');
    if (!section) return;
    const dialog = section.querySelector('[data-policy-dialog]');
    if (event.target.closest('[data-policy-open]')) dialog.showModal();
    if (event.target.closest('[data-policy-close]')) dialog.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyctrace-header-market"]) return;
  try {
    
  (() => {
    const market = document.querySelector('[data-cyc-market]');
    const icons = document.querySelector('.t4s-section-header .t4s-site-nav__icons');
    if (!market || !icons) return;
    icons.prepend(market);
    market.classList.add('is-mounted');
    const details = market.querySelector('details');
    const input = market.querySelector('[data-cyc-country-input]');
    const form = market.querySelector('form');
    market.querySelectorAll('[data-cyc-country]').forEach((button) => {
      button.addEventListener('click', () => {
        input.value = button.dataset.cycCountry;
        form.submit();
      });
    });
    document.addEventListener('click', (event) => {
      if (!market.contains(event.target)) details.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') details.open = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyctrace-privacy-notice"]) return;
  try {
    
  (() => {
    const updateBackToTop = () => {
      document.documentElement.classList.toggle('cyc-btt-visible', window.scrollY > 600);
    };
    updateBackToTop();
    window.addEventListener('scroll', updateBackToTop, { passive: true });

    const banner = document.querySelector('[data-cyc-privacy]');
    if (!banner) return;

    const key = 'cyctrace_privacy_choice_v1';
    const nativeSelector = '#shopify-pc__banner, #shopify-pc__banner__dialog, .shopify-pc__banner__dialog, [data-shopify-consent-banner]';

    const hasChoice = () => {
      try {
        if (window.localStorage.getItem(key)) return true;
      } catch (error) {
        void error;
      }
      return document.cookie.split('; ').some((item) => item.startsWith(`${key}=`));
    };

    const remember = (choice) => {
      try {
        window.localStorage.setItem(key, choice);
      } catch (error) {
        void error;
      }
      document.cookie = `${key}=${choice}; Max-Age=31536000; Path=/; SameSite=Lax`;
    };

    const hide = () => {
      banner.classList.remove('is-visible');
      document.documentElement.classList.remove('cyc-privacy-visible');
      window.setTimeout(() => {
        banner.hidden = true;
      }, 180);
    };

    const setTracking = (accepted) => {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.setTrackingConsent === 'function') {
        privacy.setTrackingConsent(accepted, () => {});
      }
    };

    banner.querySelectorAll('[data-cyc-consent]').forEach((button) => {
      button.addEventListener('click', () => {
        const accepted = button.dataset.cycConsent === 'all';
        remember(accepted ? 'all' : 'essential');
        setTracking(accepted);
        hide();
      });
    });

    window.setTimeout(() => {
      if (hasChoice() || document.querySelector(nativeSelector)) return;
      banner.hidden = false;
      document.documentElement.classList.add('cyc-privacy-visible');
      window.requestAnimationFrame(() => banner.classList.add('is-visible'));
    }, 900);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyctrace-product-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const note = document.querySelector('[data-cyc-product-checkout-note]');
    const button = document.querySelector('#MainContent button[name="add"]');
    if (note && button) {
      const buttons = button.closest('.t4s-product-form__buttons') || button.parentElement;
      buttons.after(note);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
